export default __webpack_public_path__ + "locales/fr/CreateEditRoomDialog.json?hash=72d78f26fad8e96dcee724f1874ff9f8";